import { MeFragment } from '$/GraphQL/schema/schema';
import React from 'react';

export const MeContext = React.createContext<MeFragment>(undefined as unknown as MeFragment);

export const useMe = (): MeFragment => {
  const me = React.useContext(MeContext);
  return me;
};

export const useMeMaybe = (): MeFragment | undefined => {
  const me = React.useContext(MeContext);
  return me;
};

export const useLoggedIn = (): boolean => {
  const me = useMeMaybe();
  return me !== undefined;
};
